module.exports = __webpack_public_path__ + "img/portrait.3ad2fa42.png";